import { Handshake, GraduationCap, Globe, Lightbulb, Users, ArrowRight } from "lucide-react";

const collaborators = [
  { icon: GraduationCap, text: "Education and training organizations" },
  { icon: Globe, text: "Technology and Web3 communities" },
  { icon: Lightbulb, text: "Research, innovation, and learning groups" },
  { icon: Users, text: "Industry stakeholders focused on responsible participation" }
];

const Collaboration = () => {
  return (
    <section id="collaboration" data-testid="collaboration-section" className="section-primary">
      <div className="section-glow top-left"></div>
      
      <div className="container">
        <div className="section-header">
          <div className="section-icon">
            <Handshake />
          </div>
          <h2 className="section-title">Built for Responsible Collaboration</h2>
          <div className="section-divider"></div>
          <p className="section-subtitle">
            FLEXX Academy is designed to engage in collaborative initiatives with:
          </p>
        </div>
        
        <div className="feature-list">
          {collaborators.map((item, index) => (
            <div key={index} className="feature-item">
              <div className="feature-icon">
                <item.icon />
              </div>
              <p className="feature-text">{item.text}</p>
            </div>
          ))}
        </div>
        
        <p className="gold-statement" style={{ textAlign: 'center' }}>
          All collaborations prioritize <span className="gold">clarity, transparency, and long-term value</span>.
        </p>
      </div>
    </section>
  );
};

export default Collaboration;
